var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-dialog",
    {
      attrs: { width: "700" },
      model: {
        value: _vm.cameraTourDialogVisible,
        callback: function ($$v) {
          _vm.cameraTourDialogVisible = $$v
        },
        expression: "cameraTourDialogVisible",
      },
    },
    [
      _c("customDialog", {
        scopedSlots: _vm._u([
          {
            key: "title",
            fn: function () {
              return [
                _vm._v(" " + _vm._s("ツアー") + " "),
                _c("button", { attrs: { id: "dialog_exit" } }, [
                  _c("img", {
                    attrs: {
                      src: require("@/assets/images/popup_close.png"),
                      id: "btn_img",
                    },
                    on: {
                      click: function ($event) {
                        _vm.cameraTourDialogVisible = false
                      },
                    },
                  }),
                ]),
              ]
            },
            proxy: true,
          },
          {
            key: "body",
            fn: function () {
              return [
                _c(
                  "v-row",
                  { staticClass: "ma-0 pa-0", attrs: { justify: "center" } },
                  [
                    _c(
                      "v-col",
                      { staticClass: "ma-0 pa-0", attrs: { cols: "10" } },
                      [
                        _c(
                          "v-row",
                          {
                            staticClass: "ma-0 pa-0",
                            attrs: { justify: "center" },
                          },
                          [
                            _c(
                              "v-col",
                              {
                                staticClass: "ma-0 pa-0",
                                attrs: { id: "tour_dialog_text" },
                              },
                              [
                                _c(
                                  "v-row",
                                  { staticClass: "ma-0 pa-0" },
                                  [
                                    _c(
                                      "v-col",
                                      {
                                        staticClass: "ma-0 pa-0 pl-2",
                                        attrs: { cols: "3" },
                                      },
                                      [_vm._v(" " + _vm._s("時間設定") + " ")]
                                    ),
                                    _c(
                                      "v-col",
                                      {
                                        staticClass: "ma-0 pa-0 pl-2",
                                        attrs: { cols: "4" },
                                      },
                                      [_vm._v(" " + _vm._s("店舗") + " ")]
                                    ),
                                    _c(
                                      "v-col",
                                      {
                                        staticClass: "ma-0 pa-0 pl-2",
                                        attrs: { cols: "5" },
                                      },
                                      [_vm._v(" " + _vm._s("カメラ設定") + " ")]
                                    ),
                                  ],
                                  1
                                ),
                                _vm._l(_vm.tourList, function (item, index) {
                                  return _c(
                                    "v-row",
                                    {
                                      key: index,
                                      staticClass: "ma-0 pa-0 pt-2 pb-2",
                                      attrs: { id: "dialog_row" },
                                    },
                                    [
                                      _c(
                                        "v-col",
                                        {
                                          staticClass: "ma-0 pa-0 pr-2",
                                          attrs: { cols: "3" },
                                        },
                                        [
                                          _c("v-select", {
                                            staticClass: "ml-2",
                                            attrs: {
                                              "background-color": "#272727",
                                              dark: "",
                                              items: item.timeList,
                                              dense: "",
                                              "hide-details": "",
                                              outlined: "",
                                              "item-text": "label",
                                              "item-value": "value",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "v-col",
                                        {
                                          staticClass: "ma-0 pa-0",
                                          attrs: { cols: "4" },
                                        },
                                        [
                                          _c("v-select", {
                                            staticClass: "ml-2 pr-2",
                                            attrs: {
                                              "background-color": "#272727",
                                              dark: "",
                                              items: item.storeList,
                                              dense: "",
                                              "hide-details": "",
                                              outlined: "",
                                              "item-text": "label",
                                              "item-value": "value",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "v-col",
                                        {
                                          staticClass: "ma-0 pa-0",
                                          attrs: { cols: "4" },
                                        },
                                        [
                                          _c("v-select", {
                                            staticClass: "ml-2 pr-2",
                                            attrs: {
                                              "background-color": "#272727",
                                              dark: "",
                                              items: item.cameraSettingList,
                                              dense: "",
                                              "hide-details": "",
                                              outlined: "",
                                              "item-text": "label",
                                              "item-value": "value",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "v-col",
                                        {
                                          staticClass: "ma-0 pa-0",
                                          attrs: { cols: "1" },
                                        },
                                        [
                                          _c(
                                            "v-btn",
                                            {
                                              attrs: {
                                                id: "transparent_btn_small",
                                                elevation: "0",
                                                ripple: false,
                                              },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.deleteTourItem(
                                                    index
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _c("v-img", {
                                                attrs: {
                                                  src: require("@/assets/images/close.png"),
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  )
                                }),
                                _c(
                                  "v-row",
                                  { staticClass: "ma-0 pa-0 mt-2 mb-10" },
                                  [
                                    _c(
                                      "v-btn",
                                      {
                                        attrs: { id: "blue_btn" },
                                        on: {
                                          click: function ($event) {
                                            _vm.cameraTourDialog = false
                                          },
                                        },
                                      },
                                      [_vm._v(" " + _vm._s("追加") + " ")]
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              2
                            ),
                          ],
                          1
                        ),
                        _c(
                          "v-row",
                          {
                            staticClass: "ma-0 pa-0 pb-2",
                            attrs: { align: "center", justify: "center" },
                          },
                          [
                            _c(
                              "v-btn",
                              {
                                staticClass: "ma-0 pa-0 ml-2",
                                attrs: {
                                  id: "grey_btn",
                                  width: "8rem",
                                  height: "2rem",
                                },
                                on: {
                                  click: function ($event) {
                                    _vm.cameraTourDialogVisible = false
                                  },
                                },
                              },
                              [_vm._v(_vm._s("キャンセル"))]
                            ),
                            _c(
                              "v-btn",
                              {
                                staticClass: "ma-0 pa-0 ml-2",
                                attrs: {
                                  id: "blue_btn",
                                  width: "8rem",
                                  height: "2rem",
                                },
                                on: {
                                  click: function ($event) {
                                    _vm.cameraTourDialogVisible = false
                                  },
                                },
                              },
                              [_vm._v(_vm._s("確定"))]
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }